(function () {
  const MOBILE_QUERY = '(max-width: 564px)';

  function isMobileFooter() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function syncFooterAccordion(item) {
    const toggle = item.querySelector('[data-footer-accordion-toggle]');
    const mobile = isMobileFooter();

    if (!mobile) {
      item.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    const isOpen = item.classList.contains('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
  }

  function initFooter(root) {
    const footer = root.matches('.site-footer') ? root : root.querySelector('.site-footer');
    if (!footer || footer.dataset.footerBound === 'true') return;

    footer.dataset.footerBound = 'true';

    footer.querySelectorAll('[data-footer-accordion]').forEach(syncFooterAccordion);

    footer.addEventListener('click', (event) => {
      if (!isMobileFooter()) return;

      const toggle = event.target.closest('[data-footer-accordion-toggle]');
      if (!toggle) return;

      const item = toggle.closest('[data-footer-accordion]');
      if (!item || !item.querySelector('[data-footer-accordion-panel]')) return;

      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      syncFooterAccordion(item);
    });

    window.matchMedia(MOBILE_QUERY).addEventListener('change', () => {
      footer.querySelectorAll('[data-footer-accordion]').forEach(syncFooterAccordion);
    });
  }

  function initAll() {
    document.querySelectorAll('.site-footer').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const footer = event.target.querySelector('.site-footer');
    if (footer) {
      delete footer.dataset.footerBound;
      initFooter(event.target);
    }
  });
})();